import React, { createContext, useContext, useState, useEffect } from 'react';
import { tokenManager } from '../utils/tokenManager.js';
import { storage } from '../utils/localStorage.js';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Check if user is authenticated on app load
    const checkAuth = () => {
      
      
      const hasValidToken = !tokenManager.clearExpiredTokens();
      
      
      if (hasValidToken && tokenManager.isAuthenticated()) {
        const userProfile = storage.getUserProfile();
        
        
        setIsAuthenticated(true);
        setUser(userProfile);
        
      } else {
        
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    tokenManager.logout();
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    user,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Export useAuth hook from this file
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};